import { render, staticRenderFns } from "./InfiniteScroll.vue?vue&type=template&id=63db1d9c&scoped=true"
import script from "./InfiniteScroll.vue?vue&type=script&lang=ts"
export * from "./InfiniteScroll.vue?vue&type=script&lang=ts"
import style0 from "./InfiniteScroll.vue?vue&type=style&index=0&id=63db1d9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db1d9c",
  null
  
)

export default component.exports